import React from 'react';
import ReactDOM from 'react-dom/client';

import './css/style.css';
import { ErrorBoundary } from "react-error-boundary";
import { getCookie } from './functions/getCookie';
import ProductReservation from './_project/Components/Reservation/ProductReservation/ProductReservation';
import OrderOverview from './_project/Components/Store/OrderOverview/OrderOverview';
import ReservationOverview from './_project/Components/Reservation/ReservationOverview/ReservationOverview';
 import ReservationConfirmed from './_project/Components/Reservation/ReservationOverview/ReservationConfirmed';
import CategoryReservation from './_project/Components/Reservation/CategoryReservation/CategoryReservation';
import FormBlock from './components/Form/FormBlock';
import BritgeComponentFormModal from './components/Form/BritgeComponentFormModal';
import { ProductStoreFilters, ProductStoreList, ProductForm, CartOverview, CheckoutPage } from './_project/Components/Store/';
var csrftoken = getCookie('csrftoken');

const fallback = <h6 class="text-center my-5 ">Helaas ging er iets fout bij ons. Neem aub contact met ons op.</h6>

const errorLogging = (error, info) => {
  var body = JSON.stringify(
      'JS ERROR: url: ' + window.location + '. error: '+ error.toString() + '. Component: '+ info.componentStack
  )
  const response = fetch('/server/error/', {
      method:'POST',
      body:body,
      headers: {
          'X-CSRFToken':csrftoken,
          'X-Requested-With':'XMLHttpRequest',
      }
  })
}

const readJsonScriptData = (scriptId) => {
  if (!scriptId) return null;
  const script = document.getElementById(scriptId);
  if (!script) return null;

  try {
    return JSON.parse(script.textContent || 'null');
  } catch (error) {
    console.error(`Failed to parse bootstrap data from #${scriptId}`, error);
    return null;
  }
}

const parseDatasetBool = (value, defaultValue = true) => {
  if (value === undefined || value === null || value === '') return defaultValue;
  const s = String(value).toLowerCase().trim();
  if (['true', '1', 'yes', 'y', 'on'].includes(s)) return true;
  if (['false', '0', 'no', 'n', 'off'].includes(s)) return false;
  return defaultValue;
}

const parseDatasetList = (value, fallback = []) => {
  if (!value) return fallback;
  const raw = String(value).trim();
  if (!raw) return fallback;
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed;
  } catch (e) {
    // ignore
  }
  return raw.split(',').map(s => s.trim()).filter(Boolean);
}

const parseOverviewType = (value) => {
  const v = String(value || 'list').toLowerCase().trim();
  return v === 'grid' ? 'grid' : 'list';
}

const getPrefixedAttr = (el, name) =>
  el.getAttribute(`umr-${name}`) || el.getAttribute(`britge-${name}`);

const getPrefixedId = (name) =>
  document.getElementById(`umr-${name}`) || document.getElementById(`britge-${name}`);

const normalizeComponentKind = (kind) => {
  if (!kind) return '';
  return String(kind).replace(/^(umr|britge)-/, '');
}

const renderCategoryReservation = (component) => (
  <ErrorBoundary fallback={fallback} onError={errorLogging} >
    <CategoryReservation
      category_id={component.dataset.categoryId}
      overviewType={parseOverviewType(component.dataset.overviewType)}
    />
  </ErrorBoundary>
)

const umrRoots = new WeakMap();

const renderUmrComponent = (component) => {
  const kind = normalizeComponentKind(getPrefixedAttr(component, 'component'));
  let root = umrRoots.get(component);
  if (!root) {
    root = ReactDOM.createRoot(component);
    umrRoots.set(component, root);
  }
  switch (kind) {
    case 'product-reservation':
      root.render(
        <ErrorBoundary fallback={fallback} onError={errorLogging} >
          <ProductReservation />
        </ErrorBoundary>
      );
      break;
    case 'category-reservation':
        root.render(renderCategoryReservation(component));
        break;
    case 'product-store': {
        const initialData = readJsonScriptData(component.dataset.initialDataId);
        const productListFlexWrap = parseDatasetBool(component.dataset.productListFlexWrap, true);
        const productListWidth = component.dataset.productListWidth || '25%';
        const productListFields = parseDatasetList(
          component.dataset.productListFields,
          ['name', 'price', 'price_discount', 'variants', 'add_to_cart']
        );

        root.render(
          <ErrorBoundary fallback={fallback} onError={errorLogging} >
            <ProductStoreList
              initialData={initialData}
              flexWrap={productListFlexWrap}
              width={productListWidth}
              fields={productListFields}
            />
          </ErrorBoundary>
        );
        break;
      }
    case 'product-store-filter': {
        const initialData = readJsonScriptData(component.dataset.initialDataId);
        root.render(
          <ErrorBoundary fallback={fallback} onError={errorLogging} >
            <ProductStoreFilters initialData={initialData} />
          </ErrorBoundary>
        );
        break;
      }

    case 'product-detail':
      root.render(
        <ErrorBoundary fallback={fallback} onError={errorLogging} >
          <ProductForm
            productId={component.dataset.productId}
            initialProduct={readJsonScriptData(component.dataset.initialDataId)}
          />
        </ErrorBoundary>
      );
      break;
    case 'cart':
      root.render(
        <ErrorBoundary fallback={fallback} onError={errorLogging} >
          <CartOverview initialCart={readJsonScriptData('page-context')} />
        </ErrorBoundary>
      );
      break;
    case 'checkout':
      root.render(
        <ErrorBoundary fallback={fallback} onError={errorLogging} >
          <CheckoutPage formUrl={'/rest/salesorder/checkout/'} />
        </ErrorBoundary>
      );
      break;
    case 'order-overview':
      root.render(
          <ErrorBoundary fallback={fallback} onError={errorLogging} >
            <OrderOverview />
          </ErrorBoundary>
      );
      break;
    case 'form':
      root.render(
          <ErrorBoundary fallback={fallback} onError={errorLogging} >
            <FormBlock
              url={component.dataset.url}
              initialData={readJsonScriptData(component.dataset.initialDataId)}
            />
          </ErrorBoundary>
      );
      break;
    case 'form-modal':
      root.render(
        <ErrorBoundary fallback={fallback} onError={errorLogging} >
          <BritgeComponentFormModal
            url={component.dataset.url}
            text={component.dataset.text}
            navigateUrl={component.dataset.navigateUrl}
            initialData={readJsonScriptData(component.dataset.initialDataId)}
          />
        </ErrorBoundary>
      );
      break;
    default:
      break;
  }
};

const mountUmrComponents = (root = document) => {
  const scope = root?.querySelectorAll ? root : document;
  scope.querySelectorAll('[umr-component], [britge-component]').forEach(renderUmrComponent);
};

window.mountUmrComponents = mountUmrComponents;
window.mountBritgeComponents = mountUmrComponents;
mountUmrComponents();

function resolveFormInitialDataId(el) {
  if (el.dataset.initialDataId) return el.dataset.initialDataId;
  const url = el.dataset.url || '';
  if (url.includes('/reservation/add_store/')) return 'reservation-form-data';
  return null;
}

function mountUmrFormElement(el) {
  if (!el || !el.dataset || !el.dataset.url || el.dataset.umrFormMounted || el.dataset.britgeFormMounted) return;
  el.dataset.umrFormMounted = '1';
  const order_form = ReactDOM.createRoot(el);
  order_form.render(
      <ErrorBoundary fallback={fallback} onError={errorLogging} >
        <FormBlock
          url={el.dataset.url}
          initialData={readJsonScriptData(resolveFormInitialDataId(el))}
          disappear={el.dataset.disappear === 'true'}
        />
      </ErrorBoundary>
  );
}

document.querySelectorAll('.umr-form, .britge-form').forEach(mountUmrFormElement);

window.__umrMountForm = mountUmrFormElement;
window.__britgeMountForm = mountUmrFormElement;

const reserveConfirmedEl = getPrefixedId('reserve-confirmed');
if(reserveConfirmedEl){
  const reservationConfirmedRoot = ReactDOM.createRoot(reserveConfirmedEl);
  reservationConfirmedRoot.render(
      <ErrorBoundary fallback={fallback} onError={errorLogging} >
        <ReservationConfirmed
          initialReservation={readJsonScriptData(reserveConfirmedEl.dataset.initialDataId || 'reservation-data')}
        />
      </ErrorBoundary>
  );
}

const reserveConfirmEl = getPrefixedId('reserve-confirm');
if(reserveConfirmEl){
  const reserveConfirmRoot = ReactDOM.createRoot(reserveConfirmEl);
  reserveConfirmRoot.render(
      <ErrorBoundary fallback={fallback} onError={errorLogging} >
        <ReservationOverview
          initialReservation={readJsonScriptData(reserveConfirmEl.dataset.initialDataId || 'reservation-data')}
          initialOptionsForm={readJsonScriptData(reserveConfirmEl.dataset.optionsFormId || 'reservation-options-form-data')}
        />
      </ErrorBoundary>
  );
}
// const webbuilderElement = document.getElementById('webbuilder-component')
// if(webbuilderElement){
//   const webbuilder = ReactDOM.createRoot(webbuilderElement);
//   webbuilder.render(
//       <ErrorBoundary fallback={fallback} onError={errorLogging} >
//           <ToastContainer/>
//           <Webbuilder  />
//       </ErrorBoundary>
//   );
// }


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
